import { Component, OnInit } from '@angular/core';

import { RangeKey } from '@common/enum';

import { PopupRangeService } from '../../utils/popup-range.service';

@Component({
    selector: 'aa-popup-buttons',
    templateUrl: './popup-buttons.component.html',
    styleUrls: [
        './popup-buttons.component.scss'
    ],
    standalone: false
})
export class PopupButtonsComponent implements OnInit
{
    public rangeKeys: string[];

    constructor (
        private popupRangeService: PopupRangeService
    )
    {
    }

    ngOnInit (): void
    {
        this.rangeKeys = Object.keys(RangeKey)
            .filter((_: string, id: number) =>
                [0, 1, 2, 3, 4, 5, 6, 7, 8].includes(id)
            );
    }

    onButtonClicked = (rangeKey: string) =>
    {
        this.popupRangeService.setByRangeKey(rangeKey);
    };
}
